module.exports = __webpack_public_path__ + "img/jersey_mobile.709c2e19.png";